<template>
  <div class="contents syuugyoukisoku list">
    <h2>就業規則一覧</h2>
    <div class="container">
      <loaging :isLoading="isLoading" :message="'雇用契約一覧を読み込んでいます...'"></loaging>

      <p class="notice" v-if="!isLoading && isError">雇用契約一覧の読み込みに失敗しました</p>

      <template v-else-if="!isLoading && !isError">
        <p v-if="syuugyouKisokus.length < 1" class="notice" >表示可能な所属先がありません</p>

        <div v-else class="syozokus">
          <div class="kisokus" v-for="syozoku in syuugyouKisokus">
            <h3>{{ syozoku.syozoku_name }}</h3>
            <ul v-if="syozoku.kisokus.length  > 0">
              <li v-for="kisoku in syozoku.kisokus">
                <router-link :to="{
                  name: RouterConst.SYUUGYOU_KISOKU_DETAIL,
                  params: {
                    id: kisoku.syuugyou_rule_id
                  }
                }">{{ kisoku.label }}
                </router-link>
              </li>
            </ul>
            <p v-else class="notice" >閲覧可能な就業規則はありません。</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, reactive, ref } from 'vue'
import { useSyuugyouKisokuInit } from '@/composable/syuugyoukisoku/init';
import { RouterConst } from '@/const/Router';
import VuePdfEmbed from 'vue-pdf-embed'

export default defineComponent({
  setup() {

    // 初期化処理
    const { syuugyouKisokus, isLoading, isError, getKisokuOptionsBySyozoku } = useSyuugyouKisokuInit();

    onMounted(async () => {
      await getKisokuOptionsBySyozoku()
    })

    return {
      syuugyouKisokus,
      isLoading,
      isError,
      RouterConst,
    }
  },
  components: {
    VuePdfEmbed
  }
})

</script>

<style lang="scss" scoped>
@import '@scss/components/syuugyou-kisoku.scss';
</style>